import { Illustration, type IllustrationName } from "@/components/Illustration";

/** Student-facing empty state: Owlbert, a short title in his voice, one hint, optional action. */
export function StudentEmptyState({
  illustration = "owl-search", title, hint, action, size = 120, className = "",
}: {
  illustration?: IllustrationName; title: string; hint?: string; action?: React.ReactNode; size?: number; className?: string;
}) {
  return (
    <div className={`flex flex-col items-center text-center py-6 px-4 ${className}`} data-testid="student-empty-state">
      <Illustration name={illustration} size={size} />
      <p className="mt-3 font-semibold">{title}</p>
      {hint ? <p className="mt-1 text-sm text-muted-foreground max-w-sm">{hint}</p> : null}
      {action ? <div className="mt-4">{action}</div> : null}
    </div>
  );
}
